export const REMOVED = "removed";
// Applying CHURNED requires capturing churn details first -- it can't be applied as a
// plain tag update. See the interception in Tags.jsx, CrmTableDropdown.tsx, and the
// exclusion in BulkTagAssign.tsx; the tag itself is attached backend-side
// (ChurnDetailHandler._create_fresh) once ChurnDetailsModal's submission succeeds --
// `onChurnConfirmed` only supplies an extra toast message.
export const CHURNED = "churned";
export const DISSOLVED = "dissolved";
export const MOVE_TO_SALES = "moveToSales";
export const RESTORE = "restore";
export const DELETE_ACTION = "deleteAction";
